/* eslint-disable import/no-dynamic-require */
export const getAssetPath = inAssetsPath => {
  let path = '';
  // eslint-disable-next-line global-require
  try {
    path = `${window.location.protocol}//${window.location.host}${
      require(`./assets/${inAssetsPath}`).default
    }`;
  } catch {
    window.console.error(`Cannot find image ${inAssetsPath}`);
  }
  return path;
};

export default getAssetPath;
